// extracted by mini-css-extract-plugin
module.exports = {"textButton":"textButton__OzPMI","receiptButtons":"receiptButtons__s5A0F"};